import { camposInfoAliquotasIbsCbs } from "./constants";

document.addEventListener('DOMContentLoaded', () => {
  adicionarListenersInformativo(camposInfoAliquotasIbsCbs);
});

export function adicionarListenersInformativo(campos) {
  campos.forEach(({ ids, valor, padrao }) => {
    const campo = ids.map(id => document.getElementById(id)).find(el => el);
    if (campo) {
      campo.addEventListener('keyup', (ev) => {
        handleInformativo(
          ev.target,
          window.t('interface.informativo_aliquota_ibs_cbs', { valor }),
          padrao
        );
      });
    }
  });
}

function handleInformativo(elemento, mensagem, padrao) {
  const value = elemento.value;
  if (to_float(value) !== padrao) {
    criaInformativo(elemento, mensagem);
  } else {
    removeInformativo(elemento);
  }
}

function getContainer(elemento) {
  return elemento.parentElement?.parentElement;
}

function criaInformativo(elemento, mensagem) {
  const _el = getContainer(elemento);
  if (!_el) return;

  if (_el.querySelector('.validacao-campo')) return;

  const elInfo = document.createElement('span');
  elInfo.classList.add('validacao-campo');
  elInfo.innerHTML = mensagem;
  _el.appendChild(elInfo);
}

function removeInformativo(elemento) {
  const _el = getContainer(elemento);
  if (!_el) return;
  const _elInfo = _el.querySelector('.validacao-campo');
  if (_elInfo) {
    _elInfo.remove();
  }
}